import React from 'react'
import { InputText } from '@telavita-core/react-design-kit'
import formatters from 'components/MedicalRequestForm/formatters'
import { MedicalAppointmentFormData } from 'components/MedicalRequestForm/schema'
import { Controller, useFormContext } from 'react-hook-form'

export const IssueDateInput = () => {
  const { control } = useFormContext<MedicalAppointmentFormData>()

  return (
    <Controller
      control={control}
      name="issueDate"
      render={({ field, fieldState: { error } }) => (
        <InputText
          {...field}
          onChange={(e) => field.onChange(formatters.normalizeDate(e.target.value))}
          handleClearSearchField={() => field.onChange('')}
          floatingLabel="Data de emissão do pedido médico *"
          hasError={Boolean(error?.message)}
          helperMessage={error?.message}
          helperMessageVariant={error?.message ? 'error' : 'default'}
        />
      )}
    />
  )
}
